<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a>To those who nurture the vines and craft<br/>“the drink of the gods” from their fruit.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a8ec2214